import { Swiper } from 'swiper';
import {Navigation, Autoplay, Pagination} from "swiper/modules";
Swiper.use([Navigation, Autoplay, Pagination]);

export default () => {
    const nodeSelectors = {
        container: '[js-practiice-areas-slider="container"]',
        slider: '[js-practiice-areas-slider="slider"]',
        prev: '[js-practiice-areas-slider="prev"]',
        next: '[js-practiice-areas-slider="next"]',
        pagination: '[js-practiice-areas-slider="pagination"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 500,
                autoplay: {
                    delay: 2500
                },
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                },
                pagination: {
                    el: container.querySelector(nodeSelectors.pagination),
                },
            });
        })
    }

    return Object.freeze({
        init,
    })
}